import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.PARTES_ENVOLVIDAS.BUSCAR_POR_FILTRO]({ commit }, { idAta, paginacao }) {
		const { data } = await api.partesEnvolvidas.buscarPorFiltro(idAta, paginacao)
		commit(mutationTypes.ATA.PARTES_ENVOLVIDAS.SET_LISTAGEM, data)
		return data
	},

	async [actionTypes.ATA.PARTES_ENVOLVIDAS.CRIAR](context, { idAta, parteEnvolvida }) {
		const { data } = await api.partesEnvolvidas.criar(idAta, parteEnvolvida)
		return data
	},

	async [actionTypes.ATA.PARTES_ENVOLVIDAS.VALIDAR](context, { idAta, parteEnvolvida }) {
		const { data } = await api.partesEnvolvidas.validar(idAta, parteEnvolvida)
		return data
	},
}
